import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM8.974 9h-2v2h2V9Zm6 0h2v2h-2V9Zm-7.027 3.778c1.008 4.295 7.044 4.298 8.053-.006l1.947.456C16.457 19.59 7.492 19.59 6 13.235l1.947-.457Z"
    />
  </svg>
);
export default IconSmileFilledSizeM;
